/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum LandscapeDocumentEntityType {
  Compact = 'Compact',
  Project = 'Project',
  CompactIndicator = 'CompactIndicator',
}
